<template>
  <div
    :class="{
      bg_blue: bg_blue && state_not_ready,
      hideMobileBtns: hideMobileBtns,
      'video-recorder--videoresume': isVideoresume,
      'only-audio': !hasVideo
    }"
  >
    <div class="video__container">
      <!-- <video-player
        ref="player"
        class="is-mirror"
        :options="playerOptions"
        is_recorder
        :class="{
          'controls-hide': playerOptions && playerOptions.controls === false,
          'is-hiddenn': !isMobileAny,
          'is-hidden': hasCanvas
        }"
        @ready="playerReadied"
        @canplay="onPlayerCanplay($event)"
      /> -->

      <video
        ref="player"
        class="video-recorder__player is-mirror"
        muted
        autoplay
        playsinline
        disablePictureInPicture
      ></video>

      <!-- <video
        v-if="isMobileAny"
        id="mobile-video"
        ref="mobile-video"
        class="stream-player-video is-mirror"
        :class="{
        'is-recording': state === 'recording',
        'controls-hide': playerOptions && playerOptions.controls === false,
        'is-hiddenn': !isMobileAny,
        'is-hidden': hasCanvas
        }"
        muted
        autoplay
        playsinline
        ></video> -->

      <div
        v-if="!isMobileAny && hasVideo && !disableBlur"
        class="output-wrapper is-mirror"
        :class="{ 'output-wrapper-visible': hasCanvas }"
      >
        <canvas
          id="output"
          ref="output"
          class="output"
          :style="{ width: videoWidth + 'px', height: videoHeight + 'px' }"
        ></canvas>

        <canvas
          id="canvas-logo"
          ref="canvas-logo"
          class="output hide"
          :style="{ width: videoWidth + 'px', height: videoHeight + 'px' }"
        ></canvas>

        <div v-if="(!blurLoaded && isVideoBlured) || isEffectLoading" class="preloader-wrapper">
          <vpreloader :size="24" :width="2" />
        </div>
      </div>

      <mask-on-video v-if="has_mask_on_video && hasVideo && !isMobileAny && !disableBlur" class="video-mask" />

      <div v-if="is_show_rec" :class="['video__duration', { 'video__duration-active': state === 'recording' }]">
        <img v-if="state === 'recording'" src="/static/images/elements/rec-video.png" alt="rec" />
        <span>{{ formatedTimeRemaining }}</span>
      </div>

      <div v-if="!hideBtns && !!recorder && !disabled" :class="{ 'recorder-countdown-wrapper': state === 'countdown' }">
        <button
          v-if="state === 'ready' && !disabled"
          class="video__button video__button_green mobile-hidden"
          :disabled="disabledRecordingButton"
          @click="onStartRecording"
        >
          {{ $tr('videoInterview.checkVideo.startRecord') }}
        </button>

        <button v-else-if="state === 'preparing'" class="video__button video__button_green mobile-hidden" disabled>
          {{ $tr('videoInterview.checkVideo.prepare') }}...
        </button>

        <div v-else-if="state === 'countdown'" class="countdown-circle">
          <div class="countdown-number">{{ countdown }}</div>
          <svg>
            <circle id="record-circle-outer" r="23" cx="26" cy="26" />
            <circle id="record-circle" r="23" cx="26" cy="26" />
            <circle id="record-circle-inner" r="20.5" cx="26" cy="26" />
          </svg>
        </div>

        <button
          v-else-if="state === 'recording'"
          class="video__button video__button_red mobile-hidden"
          @click="onStopRecording"
        >
          {{
            !isVideoresume
              ? $tr('videoInterview.checkVideo.stopRecord')
              : $tr('vacancy.openRegistrationVideoresume.video.stop')
          }}
        </button>

        <button v-else-if="state === 'uploading'" class="video__button video__button_green mobile-hidden" disabled>
          {{ $tr('videoInterview.checkVideo.upload') }}... {{ uploadProgress }}%
        </button>
      </div>
    </div>

    <!-- uncomment this for blur enabling and comment next div
      <div
      v-if="canPlay && !isMobileAny && hasVideo && stream && stream.active"
      v-tooltip.top-center="$tr('common.iconTooltips.backgroundBlur')"
      class="blur-icon"
      :class="{ 'is-active': isVideoBlured }"
      @click="toggleBlur"
      ></div>
    -->
    <div
      v-if="canPlay && !isMobileAny && hasVideo && stream && stream.active && getProcessName !== 'x5'"
      v-tooltip.top-center="$tr('common.iconTooltips.backgroundBlurDisabled')"
      class="blur-icon"
      :class="{ 'is-active': isVideoBlured }"
    ></div>
  </div>
</template>

<script>
// import bodyPix from '@tensorflow-models/body-pix';
import * as tf from '@tensorflow/tfjs';
import * as bodyPix from '@tensorflow-models/body-pix';
import { mapState, mapGetters } from 'vuex';
import PROCESS_NAMES from '@/process/names';

import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';
import { RecordRTCPromisesHandler } from 'recordrtc';
import { videoPlayer } from 'vue-video-player';
import isMobile from 'ismobilejs';
import moment from 'moment';

import 'video.js/dist/video-js.css';
import MaskOnVideo from '@/components/VideoRecorder/maskOnVideo/index';

export default {
  name: 'VideoRecorder',

  components: {
    MaskOnVideo,
    videoPlayer
  },

  mixins: [SafariBrowserDetector],

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    hideBtns: {
      type: Boolean,
      default: false
    },

    disabledRecordingButton: {
      type: Boolean,
      default: false
    },

    hasVideo: {
      type: Boolean,
      default: true
    },

    isVideoresume: {
      type: Boolean,
      default: false
    },

    duration: {
      type: Number,
      default: null
    },

    action: {
      type: String,
      default: null
    },

    uploadProgress: {
      type: Number,
      default: null
    },

    is_big: {
      type: Boolean,
      default: false
    },

    bg_blue: {
      type: Boolean,
      default: false
    },

    has_mask_on_video: {
      type: Boolean,
      default: true
    },

    hideMobileBtns: {
      type: Boolean,
      default: false
    },

    width: {
      type: Number,
      default: 0
    },

    height: {
      type: Number,
      default: 0
    },

    isBlurButtonHidden: {
      type: Boolean,
      default: false
    },

    isX5Blurred: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      disableBlur: false,
      isEffectLoading: true,
      recorder: null,
      player: null,
      // need_show: false,
      state_not_ready: true,
      state: 'preparing', // preparing, ready, recording, uploading
      playerOptions: {
        sources: [
          {
            type: 'video/mp4',
            src: '/static/blank.m4v'
          }
        ],

        playsinline: true,
        fullscreen: false,
        controls: false,
        autoplay: true,
        muted: true,
        height: this.height || 296,
        width: this.width || 444
      },

      isMobile: isMobile.phone,
      isMobileAny: isMobile.any,
      stream: null,
      timeRemaining: this.duration,
      start_timestamp: null,
      countdown: null,
      record_timer: null,
      streamLoaded: false,
      streamCanvas: null,
      mediaRecorder: null,
      recordedBlobs: [],
      analyser: null,
      bufferLength: null,
      canPlay: false,
      hasCanvas: false,
      destroy: false,
      loadAndPredicted: false,
      videoWidth: 0,
      videoHeight: 0,
      net: null,
      edgeBlurAmount: 13,
      flipHorizontal: false,
      videoElement: null,
      canvas: null,
      context: null,
      blurLoaded: false
    };
  },

  computed: {
    ...mapState('interview/videointerview', ['enabledResolutions', 'devices']),

    ...mapState('services', ['isVideoBlured']),

    ...mapGetters('process', ['getProcessName']),

    ...mapState('record_interview', { recordInterviewItem: 'item' }),

    backgroundBlurAmount() {
      return this.isVideoBlured ? 6 : 0;
    },

    formatedTimeRemaining() {
      return moment.duration(this.timeRemaining, 'seconds').format('mm:ss', { trim: false });
    },

    is_show_rec() {
      return (this.state === 'ready' || this.state === 'recording' || this.state === 'countdown') && this.timeRemaining;
    }
  },

  watch: {
    duration(val) {
      this.setRecordingDuration(val);
      this.timeRemaining = val;
    },

    uploadProgress(val) {
      if (typeof val === 'number') {
        this.state = 'uploading';
      }
    },

    disabled(val) {
      if (val === true) {
        this.stopRecording();
        this.state = 'ready';
      } else {
        this.state = 'ready';
      }
    },

    state: {
      immediate: true,
      handler(val) {
        this.$emit('setState', val);

        if (val === 'ready') {
          this.state_not_ready = false;
        }
      }
    },

    recorder: {
      immediate: true,
      handler(val) {
        this.$emit('setRecorder', val);
      }
    },

    action: {
      immediate: true,
      handler(val) {
        switch (val) {
          case 'start':
            this.startRecording();
            break;
          case 'stop':
            this.stopRecording();
            break;
        }
      }
    }
  },

  async mounted() {
    await this.getMediaStream();
  },

  beforeDestroy() {
    if (this.stream) {
      const tracks = this.stream.getTracks();
      tracks.forEach(track => track.stop());
    }
    this.destroy = true;
    this.loadAndPredicted = false;
    this.hasCanvas = false;
  },

  methods: {
    async loadAndPredict() {
      this.isEffectLoading = true;
      this.loadAndPredicted = true;
      const videoElement = document.querySelector('.video__container video.vjs-tech');

      if (videoElement) {
        const proportion = videoElement.videoWidth / videoElement.videoHeight;
        videoElement.width = 296 * proportion;
        videoElement.height = 296;
        window.videoElement = videoElement;
        this.videoWidth = videoElement.width;
        this.videoHeight = videoElement.height;
        this.videoElement = videoElement;
      }

      if (!this.net) {
        this.net = await bodyPix.load();
      }

      const self = this;
      this.canvas = document.getElementById('output');
      this.context = this.canvas.getContext('2d');
      this.canvasLogo = document.getElementById('canvas-logo');
      this.contextLogo = this.canvasLogo.getContext('2d');
      this.drawLogo();

      if (videoElement && !self.destroy) {
        this.bodySegmentationFrame();
      }

      this.isEffectLoading = false;
    },

    async bodySegmentationFrame() {
      if (this.getProcessName === PROCESS_NAMES.X5) {
        const segmentation = await this.net.segmentPerson(document.querySelector('.video__container video.vjs-tech'));
        this.blurLoaded = true;
        bodyPix.drawBokehEffect(
          this.canvas,
          document.querySelector('.video__container video.vjs-tech'),
          segmentation,
          this.backgroundBlurAmount,
          this.edgeBlurAmount,
          this.flipHorizontal
        );

        this.context.drawImage(this.canvasLogo, 0, 0);

        if (!this.destroy) {
          requestAnimationFrame(this.bodySegmentationFrame);
        }

        if (!this.hasCanvas) {
          this.hasCanvas = true;
        }
      } else {
        if (this.isVideoBlured) {
          const segmentation = await this.net.segmentPerson(document.querySelector('.video__container video.vjs-tech'));
          this.blurLoaded = true;
          bodyPix.drawBokehEffect(
            this.canvas,
            document.querySelector('.video__container video.vjs-tech'),
            segmentation,
            this.backgroundBlurAmount,
            this.edgeBlurAmount,
            this.flipHorizontal
          );

          this.context.drawImage(this.canvasLogo, 0, 0);

          if (!this.destroy) {
            requestAnimationFrame(this.bodySegmentationFrame);
          }
        } else {
          this.renderFrame();
        }

        if (!this.hasCanvas) {
          this.hasCanvas = true;
        }
      }
    },

    drawLogo() {
      let base_image = new Image();
      base_image.src = '/static/process/x5/x5_logo.svg';
      base_image.onload = () => {
        this.contextLogo.drawImage(base_image, 20, 15, 100, 31);
      };
      this.contextLogo.scale(-1, 1);
    },

    renderFrame() {
      if (
        !document.querySelector('.video__container video.vjs-tech') ||
        !document.querySelector('.video__container video.vjs-tech').width
      ) {
        return;
      }
      this.canvas.width = this.canvas.scrollWidth;
      this.canvas.height = this.canvas.scrollHeight;

      var videoSize = {
        width: document.querySelector('.video__container video.vjs-tech').videoWidth,
        height: document.querySelector('.video__container video.vjs-tech').videoHeight
      };
      var canvasSize = { width: this.canvas.width, height: this.canvas.height };
      var renderSize = this.calculateSize(videoSize, canvasSize);
      var xOffset = (canvasSize.width - renderSize.width) / 2;
      // this.context.scale(-1, 1);
      // this.context.translate(-this.canvas.width, 0);
      this.context.drawImage(
        document.querySelector('.video__container video.vjs-tech'),
        xOffset,
        0,
        renderSize.width,
        renderSize.height
      );

      requestAnimationFrame(this.bodySegmentationFrame);
    },

    calculateSize(srcSize, dstSize) {
      var srcRatio = srcSize.width / srcSize.height;
      var dstRatio = dstSize.width / dstSize.height;
      if (dstRatio > srcRatio) {
        return {
          width: dstSize.height * srcRatio,
          height: dstSize.height
        };
      } else {
        return {
          width: dstSize.width,
          height: dstSize.width / srcRatio
        };
      }
    },

    async toggleBlur() {
      this.$store.commit('services/setVideoBlur', !this.isVideoBlured);
    },

    setRecordingDuration(value) {
      this.recorder.recordRTC.setRecordingDuration(value * 1000).onRecordingStopped(this.onCompleteRecording);
    },

    startRecording() {
      this.state = 'countdown';

      this.countdown = 3;
      const countdownTimer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          this.countdown = 0;
          clearInterval(countdownTimer);
        }
      }, 1000);

      setTimeout(() => {
        // console.log('setTimeout');
        const timeout = this.timeRemaining;
        this.start_timestamp = new Date().getTime();
        this.state = 'preparing';

        if (this.timeRemaining === 0) {
          this.record_timer = setInterval(() => {
            // console.log('setInterval 0: ', this.timeRemaining);
            const current_time = new Date();
            const diff_timestamp = (current_time.getTime() - this.start_timestamp) / 1000;
            this.timeRemaining = timeout + Math.floor(diff_timestamp);
          }, 1000);
        } else {
          this.record_timer = setInterval(() => {
            const current_time = new Date();
            const diff_timestamp = (current_time.getTime() - this.start_timestamp) / 1000;
            this.timeRemaining = timeout - Math.floor(diff_timestamp);
            // console.log('setInterval: ', this.timeRemaining);

            if (this.timeRemaining <= 0) {
              this.stopRecording();
            }
          }, 1000);
        }

        if (!this.hasVideo) {
          this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'audio/webm' });
        } else {
          // для НЛМК компании включаем HD video и кодеки vp9, vp8 если они поддерживаются браузером и системой
          if (this.recordInterviewItem?.company?.id == 3984) {
            if (MediaRecorder.isTypeSupported('video/mp4')) {
              this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'video/mp4' });
            } else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9,opus')) {
              this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'video/webm;codecs=vp9,opus' });
            } else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp8,opus')) {
              this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'video/webm;codecs=vp8,opus' });
            } else if (MediaRecorder.isTypeSupported('video/webm;codecs=h264')) {
              this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'video/webm;codecs=h264' });
            } else {
              this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'video/webm' });
            }
          } else {
            if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9,opus')) {
              this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'video/webm;codecs=vp9,opus' });
            } else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp8,opus')) {
              this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'video/webm;codecs=vp8,opus' });
            } else if (MediaRecorder.isTypeSupported('video/webm;codecs=h264')) {
              this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'video/webm;codecs=h264' });
            } else if (MediaRecorder.isTypeSupported('video/webm')) {
              this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'video/webm' });
            } else {
              this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'video/mp4' });
            }
          }
        }

        this.mediaRecorder.ondataavailable = event => {
          this.recordedBlobs.push(event.data);
        };
        this.mediaRecorder.start(100); // collect 100ms of data
        this.state = 'recording';
      }, 3000);
    },

    stopRecording() {
      this.state = 'preparing';

      // Сброс таймера
      if (this.record_timer) {
        clearInterval(this.record_timer);
      }
      this.start_timestamp = null;

      this.mediaRecorder.stop();
      this.onCompleteRecording();
    },

    onStartRecording() {
      this.state = 'preparing';
      this.$emit('start');
    },

    onStopRecording() {
      this.state = 'preparing';
      this.$emit('stop');
    },

    onCompleteRecording() {
      const recordedblob = new Blob(this.recordedBlobs, { type: this.mediaRecorder.mimeType });

      this.$emit('complete', { blob: recordedblob });
    },

    setState(state) {
      this.state = state;
    },

    playerReadied() {
      // Disable video in window for YaBrowser
      const video = this.$el.querySelector('.video__container video.vjs-tech');
      video.setAttribute('pip', false);
    },

    onPlayerCanplay() {
      this.canPlay = true;

      if (this.stream && this.stream.active) {
        if (this.canPlay && !this.isMobileAny && this.hasVideo && !this.disableBlur) {
          // const videoElement = document.querySelector('.video__container video');
          if (!this.loadAndPredicted) {
            this.loadAndPredict();
          }
        }

        if (this.getProcessName === PROCESS_NAMES.X5) {
          this.loadAndPredict();
        }
      }
    },

    getConstraints() {
      if (!this.hasVideo) {
        return {
          audio: true,
          video: false,
          echoCancellation: true
        };
      }

      if (!this.enabledResolutions || !this.enabledResolutions.length) {
        // для НЛМК компании включаем HD video
        if (this.recordInterviewItem?.company?.id == 3984) {
          return {
            audio: true,
            video: {
              // optional: [
              //   { minWidth: 480 },
              //   { minWidth: 640 },
              //   { minWidth: 1024 },
              //   { minWidth: 1280 },
              //   { minWidth: 1920 }
              // ],

              width: { min: 640, ideal: 1920, max: 1920 },
              height: { min: 480, ideal: 1080, max: 1080 },
              frameRate: { ideal: 30, max: 60 },
              bitrate: 20000
            },

            echoCancellation: true
          };
        } else {
          return {
            audio: true,
            video: true,
            echoCancellation: true
          };
        }
      }

      const hasDesignedProportion = [...this.enabledResolutions]
        .filter(item => {
          return item.ratio === '16:9';
        })
        .sort((a, b) => {
          return b.width - a.width;
        })[0];

      if (hasDesignedProportion) {
        return {
          audio: true,
          video: {
            facingMode: { exact: 'user' },
            width: { exact: hasDesignedProportion.width },
            height: { exact: hasDesignedProportion.height },
            deviceId: { exact: this.devices[0] }
          },

          echoCancellation: true
        };
      }

      const findBestResolution = [...this.enabledResolutions].sort((a, b) => {
        return b.width - a.width;
      });

      if (findBestResolution) {
        return {
          audio: true,
          video: {
            facingMode: { exact: 'user' },
            width: { exact: findBestResolution[0].width },
            height: { exact: findBestResolution[0].height },
            deviceId: { exact: this.devices[0] }
          },

          echoCancellation: true
        };
      }
      return { audio: true, video: true, echoCancellation: true };
    },

    async getMediaStream() {
      const constraints = this.getConstraints();

      console.log(constraints);

      await navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          this.recorder = new RecordRTCPromisesHandler(stream, {});
          this.stream = stream;
          this.setRecordingDuration(this.duration);

          // const video = window.URL ? window.URL.createObjectURL(stream) : stream;
          // this.playerOptions.sources[0].src = stream;
          this.$refs.player.srcObject = stream;

          this.$refs.player.onloadedmetadata = () => {
            this.$refs.player.play();
          };

          if (this.state !== 'countdown' && this.state !== 'recording') {
            this.state = 'ready';
          }
        })
        .catch(e => {
          console.log(e);
          this.$emit('noWebcam');
        });
    }
  }
};
</script>

<style lang="scss">
// @import '@/styles/variables.scss';

.showed_player {
  opacity: 1;
  height: auto;
  overflow: visible;
}
.hidden_player {
  opacity: 0;
  height: 0;
  overflow: hidden;
}
.video__container {
  position: relative;
  width: 100%;
  // height: 296px;
  // min-height: 296px;
  height: auto;
  background-color: #000;

  // .video-js .vjs-tech {
  //   position: static !important;
  //   width: 640px !important;
  //   height: 480px !important;
  // }
}

.only-audio {
  .video__container {
    // background-image: url('/static/images/elements/equalizer.jpg');
    background-image: url('/static/images/elements/equalizer2.jpg');
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;

    .video-js {
      background-color: transparent;
    }
  }

  ::v-deep {
    .video-js {
      opacity: 0;
    }
  }
}

.bg_blue {
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #f5f9ff;
  }
  .video__container {
    background-color: #f5f9ff;
  }
}

.video__button {
  position: absolute;
  bottom: 0;
  left: 0;
  border: none;
  width: 100%;
  font-size: 20px;
  color: #fff;
  line-height: 60px;
  letter-spacing: 1px;
  font-weight: bold;
  // font-family: Roboto;
  z-index: 3;
}

.video__button_green {
  cursor: pointer;
  background-color: $green;
}

.video__button_red {
  background-color: rgba(176, 0, 32, 0.5);

  &:hover,
  &:focus,
  &:active {
    background-color: rgba(176, 0, 32, 0.5);
  }
}

.video__countdown {
  background-color: #404040;
}

.video__countdown__number {
  color: #747474;
  font-size: 25px;
  padding-left: 10px;
  padding-right: 10px;
  transition: 0.5s;
}

.video__countdown__number-active {
  color: #fdfdfd;
  transition: 0.5s;
}

.video__duration {
  position: absolute;
  top: 16px;
  left: 16px;
  padding: 8px 15px;
  background: rgba(244, 245, 247, 0.5);
  color: #607183;
  font-size: 15px;
  font-weight: bold;
  z-index: 4;
  line-height: 22px;
  border-radius: 2px;
  text-align: center;
  display: flex;
  align-items: center;

  // &-active {
  //   color: #F65046;
  //   padding: 8px 13px 9px 11px;
  // }

  span {
    position: relative;
  }

  img {
    display: inline-block;
    margin-right: 8px;
  }
}

.recorder-countdown-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  padding: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  box-sizing: border-box;
}

.countdown-circle {
  position: relative;
  height: 54px;
  width: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 3;

  .countdown-number {
    color: #9faab6;
    display: inline-block;
    position: relative;
    z-index: 2;
    font-weight: 500;
    font-size: 22px;
    line-height: 53px;
    user-select: none;
  }

  svg {
    position: absolute;
    top: 0;
    right: 0;
    width: 54px;
    height: 54px;
    transform: scale(-1, -1) rotate(90deg);
    border-radius: 50%;
  }

  svg circle#record-circle {
    stroke-dasharray: 140px;
    stroke-dashoffset: 0px;
    stroke-linecap: round;
    stroke-width: 5px;
    stroke: none;
    fill: none;
    animation: countdown 3s linear;
  }

  svg circle#record-circle-outer {
    stroke-width: 5px;
    stroke: #d0d4de;
    fill: none;
  }

  svg circle#record-circle-inner {
    fill: #fff;
  }
}

@keyframes countdown {
  from {
    stroke-dashoffset: 0;
    stroke: $green;
  }
  to {
    stroke-dashoffset: 140px;
    stroke: $green;
  }
}

@keyframes countdown_videoresume {
  from {
    stroke-dashoffset: 0;
    stroke: #a44bcd;
  }
  to {
    stroke-dashoffset: 140px;
    stroke: #a44bcd;
  }
}

/* Safari 10.1+ */
@media not all and (min-resolution: 0.001dpcm) {
  .video__duration {
    padding: 0 3px;
  }
}

.hideMobileBtns {
  .mobile-hidden {
    @media screen and (max-width: 960px) {
      display: none;
    }
  }
}

.vid-int-videoTest__video-container {
  overflow: hidden;
}
</style>

<style lang="scss" scoped>
.video-mask {
  pointer-events: none;
  // display: none;
  @media only screen and (max-width: 1024px) {
    display: none;
  }
}

// .stream-player-video {
//   width: 100% !important;
//   height: auto !important;

//   @media only screen and (min-width: 1025px) {
//     height: 296px !important;
//     width: 444px !important;
//   }

//   @media only screen and (max-width: 480px) {
//     height: 192px !important;
//   }

//   &.is-recording {
//     @media only screen and (max-width: 480px) {
//       height: 100% !important;
//     }
//   }
// }

.is-hidden {
  opacity: 0;
  visibility: hidden;
  width: 0 !important;
  height: 0 !important;
  position: absolute;
  left: -9999px;
  margin: 0;
  padding: 0;

  .vjs-tech {
    display: none;
  }
}

.video-recorder {
  &__player {
    width: 100%;
    display: block;
    max-height: 600px;

    &.is-mirror {
      transform: scaleX(-1);
    }
  }
}

.video-recorder--videoresume {
  .video__button {
    padding: 8px 0;
    // font-family: 'Euclid Circular A';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    color: #ffffff;
    text-transform: lowercase;
  }
  .video__button_green {
    background: linear-gradient(327.35deg, #848bd3 0%, #bc89e6 100%);
    &:hover,
    &:focus,
    &:active {
      background: linear-gradient(327.35deg, #848bd3 0%, #bc89e6 100%);
    }
  }

  .video__duration {
    background: #f4f5f7;
    border-radius: 2px;
    // font-family: 'Euclid Circular A';
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    color: #8d8d8d;
  }

  .video__button_red {
    background-color: #fafafa;
    color: #b36565;

    &:hover,
    &:focus,
    &:active {
      background-color: #fafafa;
      color: #b36565;
    }
  }

  .countdown-circle {
    svg circle#record-circle {
      animation: countdown_videoresume 3s linear;
    }
  }
}

canvas {
  margin-top: 230px;
}

.blur-icon {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  opacity: 0.4;
  background: url(/static/images/elements/icon-background-blur.svg) center no-repeat;
  background-size: 24px;
  cursor: pointer;
  z-index: 9;
  border: 1px solid #fff;
  border-radius: 4px;

  &.is-active {
    opacity: 1;
  }
}

.is-hiddenn {
  // display: none;
  // opacity: 0 !important;
  // visibility: hidden;
  // position: absolute;
  left: 0;
  top: 0;
  // opacity: 0;
  z-index: -1;
}

.output-wrapper {
  position: absolute;
  // width: 444px;
  // height: 296px;
  left: 0;
  top: 0;
  margin-top: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: -1;

  &.output-wrapper-visible {
    z-index: 2;
    position: relative;
  }
}

.output {
  margin-top: 0 !important;
  width: 100%;
  max-height: 100%;
  // transform: scale(-1, 1);

  &.hide {
    display: none;
  }
}

.preloader-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.5);
}
</style>
